import React from 'react'
import { ModalVariant } from '@at/design-system-patterns'
import {
    LeasingBoldText,
    LeasingModalParagraph,
    LeasingModalSubtitle,
    LeasingModalTitle,
} from './leasing-modal-title.styles'
import { StyledInfoModal } from '../search-listing-details/search-listing-details.styles'

interface SaveSearchModalProps {
    handleHideModal: () => void
}

export const LeasingInfoModal = ({ handleHideModal }: SaveSearchModalProps) => {
    return (
        <StyledInfoModal
            isShowing={true}
            closeText={'Back'}
            hideFn={() => handleHideModal()}
            variation={ModalVariant.SLIDE}
            hasBackLink={false}
            focusId="modal-button"
            className="info-modal"
        >
            <LeasingModalTitle as="h2">Leasing a vehicle with Autotrader</LeasingModalTitle>
            <LeasingModalSubtitle as="h3">What is leasing?</LeasingModalSubtitle>
            <LeasingModalParagraph as="p">
                Leasing is a way of driving a brand-new vehicle without actually owning it. Unlike buying on finance,
                leasing is more similar to renting. You don’t actually own the vehicle, you just lease it for a set
                period of time.
            </LeasingModalParagraph>
            <LeasingBoldText as="h4">How does leasing work?</LeasingBoldText>
            <LeasingModalParagraph as="p">
                Firstly, you decide how much you would like to pay upfront and how long you would like to lease the
                vehicle for (this is usually between 2 and 5 years).
            </LeasingModalParagraph>
            <LeasingModalParagraph as="p">
                After you’ve decided that, you make monthly payments for the duration of your lease. At the end of your
                contract, simply return the vehicle back to the provider and you can lease another brand-new vehicle
                again if you would like.
            </LeasingModalParagraph>
            <LeasingBoldText as="h4">How do I start my order?</LeasingBoldText>
            <LeasingModalParagraph as="p">
                Once you have found the vehicle you would like to lease, we will collect some details from you to start
                your application for lease credit.
            </LeasingModalParagraph>
            <LeasingModalParagraph as="p">
                If your application is approved, you’ll then sign your documentation and set up your monthly payments.
                Once this is done, simply arrange a suitable time for the vehicle to be delivered to you.
            </LeasingModalParagraph>
        </StyledInfoModal>
    )
}
